import React from "react"

import CreditCard from "./assets/CreditCard"
import MoneyTransfer from "./assets/MoneyTransfer"
import Cash from "./assets/Cash"

export default {
	heading: "Способы оплаты",
	textarea: "Принимаем деньги от населения и организаций в любом формате",
	methods: [
		{
			id: 0,
			mediaContent: <CreditCard />,
			heading: "Картой",
			textarea: (
				<>
					Просто приложи
					<br />и платёж пройдёт
				</>
			),
		},
		{
			id: 1,
			mediaContent: <MoneyTransfer />,
			heading: "Переводом",
			textarea: (
				<>
					Там всё через один
					<br />
					банк делается
				</>
			),
		},
		{
			id: 2,
			mediaContent: <Cash />,
			heading: "Наличными",
			textarea: (
				<>
					Пошуршим купюрами,
					<br />
					пока будем пересчитывать
				</>
			),
		},
	],
}
